module.exports = __webpack_public_path__ + "img/IT解决方案.7be97625.png";